<template>
  <jd-dialog
    title="选择模板"
    width="45%"
    :visible.sync="isShow"
    :before-close="cancelDialog"
    class="new-input-box"
    append-to-body
    @confirm="submitForm"
    @close="cancelDialog"
  >
    <div>
      <contentCom
        :tableInfo="tableInfo"
        :tableData="temList"
        :selection="selection"
        :loading="isShowLoading"
        :isShowEditBtn="isShowEditBtn"
        :isShowSelectTem="isShowSelectTem"
        :delByApi="delByApi"
        :isEdit="isEdit"
        :noShow="noShow"
        :pageInfo="pageInfo"
        @delFn="delContentFn"
        @selectItemChange="handleSelectionChange"
        @selectTem="selectTemFn"
        @updatePageInfo="updatePageInfo"
      >
      </contentCom>
    </div>
  </jd-dialog>
</template>
<script>
import { getContentTemplatePage,deleteContentTemplate } from "@/api/jhk/paradiseAndTaskCommonController";
import contentCom from "@/views/interactiveMarketing/activity/xhsSunGift/components/contentCom.vue";
export default {
  components: {
    contentCom,
  },
  props: {
    tableInfo: {
      type: Array,
      required: true,
      default: () => [],
    },
    contentList: {
      type: Array,
      required: true,
      default: () => [],
    },
    limitNum: {
      type: Number,
      default: 20,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  data() {
    return {
      noShow: false,
      selectList: [],
      temList: [],
      isShowSelectTem: true,
      selection: true,
      isShowEditBtn: false,
      delByApi: true,
      pageInfo: {
        current: 1,
        size: 10,
      },
      isShowLoading: false,
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.pageInfo.current = 1;
    this.pageInfo.size = 10;
    this.getList();
  },
  methods: {
    updatePageInfo(pageInfo) {
      this.pageInfo = pageInfo;
      this.getList();
    },
    async getList() {
      this.temList = [];
      this.isShowLoading = true;
      try {
        const res = await getContentTemplatePage(this.pageInfo);
        this.isShowLoading = false;
        if (res.code == 1) {
          this.temList = res.data.records;
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.isShowLoading = false;
      }
    },
    submitForm() {
      if (this.selectList.length > 0) {
        this.$emit("selectItemChange", this.selectList, "manual");
        this.cancelDialog();
      } else {
        this.$message.error("请选择模板");
      }
    },
    cancelDialog() {
      this.$emit("update:isShow", false);
    },
    // 删除模板
    async delContentFn(row) {
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        try {
          const res = await deleteContentTemplate({id: row.id});
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getList();
          } else {
            this.$message.error(res.message);
          }
        } catch (error) {
          this.$message.error("删除失败");
        }
      });
    },
    // 选择单个模板
    selectTemFn(row) {
      const list = [{imageUrl: row.shareUrl,content: row.shareContext}]
      if (!this.isEdit) {
        if (this.contentList.length >= this.limitNum) {
          this.$message.error(`添加内容已超出上限${this.limitNum}个`);
          return;
        } else {
          this.cancelDialog();
          this.$emit("selectItemChange", list, "manual");
        }
      } else {
        this.cancelDialog();
        this.$emit("selectItemChange", list, "manual");
      }
    },
    // 选择多个模板
    handleSelectionChange(row) {
      if (this.contentList.length + row.length > this.limitNum) {
        this.$message.error(`添加内容已超出上限${this.limitNum}个`);
        return;
      } else {
        this.selectList = row.map(item => ({imageUrl: item.shareUrl,content: item.shareContext}));
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
